import { required } from 'vuelidate/lib/validators'

/**
 * Model "class" for Option - defines useful field metadata for building and validating forms
 */

export default {
    fields: {
        model: {
            label: 'LABEL_MODEL',
            type: 'select',
            options: {    // https://platform.openai.com/docs/models
                'gpt-3.5-turbo': 'gpt-3.5-turbo',
                'gpt-4': 'gpt-4',
                'gpt-4-turbo': 'gpt-4-turbo',
                'gpt-4o': 'gpt-4o',
                'gpt-4o-mini': 'gpt-4o-mini',
                'davinci-002': 'davinci-002',
                'babbage-002': 'babbage-002',
            },
            validations: { required },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
        prompt: {
            label: 'LABEL_PROMPT',
            type: 'textarea',
            validations: { required },
            invalidFeedback: { required: 'MESSAGE_FIELD_REQUIRED' }
        },
        // temperature: {
        //     label: 'LABEL_TEMPERATURE',
        //     type: 'number',
        //     step: 0.01
        // },
        // max_tokens: {
        //     label: 'LABEL_MAX_TOKENS',
        //     type: 'number'
        // }
    }
}
